import { takeEvery, fork, put, all, call, takeLatest, select } from "redux-saga/effects";
import { WpActionTypes, WpPostInfo } from "./wpTypes";
import { Utils } from "helpers/utils";
import {
  loadPostTitleApiV2, loadPostConverApi2, loadPostInfoApi, getRoleUnreadCountApi, loadDllEmployeeApi, loadTaskDashApiV2,
  loadSubTaskApi,
  loadTaskDashTagsApiV2, loadTaskDashboardByDivApi, tagMasterCatLoadApi,
  loadTaskDashRecuranceApi,
  loadTaskDashStatusrangeV2Api
} from "../../api/wpapi";

import { loadPostInfo, setPostInfoOnly } from "./wpActions";
import { apiOk, apiErr } from "../workplace/wpActions";
import { DbUtils } from "helpers/dbUtils";
import { TABS, WpModes } from "../../constants";
import { StorageUtils } from "helpers/storageutils";

const WP_CONVER_PAGE_SIZE = 50;

/* saga function */
function* loadPostTitleSaga({ type, payload:
  { wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, callFrom, taskStatus
    , filterFromDash, taskResponder, taskAssigner, taskRequester
    , taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode, sortMode
  } }: any) {
  try {
    // console.log('loadPostTitleSaga:', {
    //   wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, callFrom, taskStatus
    //   , filterFromDash, taskResponder, taskAssigner, taskRequester
    //   , taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode
    // });
    const isLoadFromStarup = !keyword && tagSet.length <= 0 && (tagIds ?? []).length <= 0 && filterUnRead == false && filterNotClose == true && empFilterType == 1 && (tagCatMatchedAll ?? []).length <= 0;
    if (isLoadFromStarup) {
      try {
        const rs: any[] = yield call(DbUtils.wp_load_post_title, wpMode, null);
        // console.log('put title from storage:', rs);
        if (rs != null) {
          yield put(apiOk(type, { wpMode, titles: rs }));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }
    }
    // console.log('loadPostTitleSaga:', { keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, tagCatMatchedAll, isLoadFromStarup });
    // Scoped by wpMode - Workplace's and Task's title loads run concurrently on mount/redirect,
    // and previously shared one unscoped flag, so whichever finished first could clear it before
    // the other (unrelated) mode's load ever saw it, leaving the real target unprotected.
    const redirectWpId = Utils.GetRedirectPostId(wpMode);
    // console.log('setActivePostId saga load - start ' + wpMode);
    const includePostIds: string[] = redirectWpId ? [redirectWpId] : [];
    //const response: Promise<any> = yield call(loadPostTitleApi, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, includePostIds, tagCatMatchedAll);
    const response: any[] = yield call(loadPostTitleApiV2, wpMode, keyword, tagSet, memberRole, tagIds, filterUnRead, filterNotClose, empFilterType, includePostIds, tagCatMatchedAll, callFrom
      , taskStatus, filterFromDash, taskResponder, taskAssigner, taskRequester, taskRange1, taskRange2, includeTaskRecurance, filterTaskDueMode, sortMode); // 20250815
    // console.log('setActivePostId saga load - done ' + wpMode );
    // Deliberately NOT clearing the flag here even though this fetch just consumed it - it's a
    // time-windowed guard (see Utils.SetRedirectPostId), not single-use. WorkplaceTitle.tsx and
    // Chats/index.tsx read the same flag to decide whether to protect the active post from their
    // own unrelated mount-time "clear as a side effect" bootstrap effects, and clearing it as soon
    // as this fetch used it left them unprotected whenever they happened to run afterward - an
    // ordering that flips with real network latency. Let it expire on its own.
    if (isLoadFromStarup) {
      DbUtils.wp_load_post_title(wpMode, response);
    }
    //  console.log('loadPostTitleSaga:', response);

    // 20250815 make draft flag
    const draftPostIds = Utils.WpDraft_GetAllPostId();
    for (const item of response) {
      item.draft = draftPostIds.includes(item.postId);
    }

    yield put(apiOk(type, { wpMode, titles: response }));
  } catch (e) {
    Utils.HandleException(e, true); // 20250430 เปลี่ยนเป็น true ชั่วคราว เพื่อดู error
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* loadMorePostTitleSaga({ type, payload: { wpMode } }: any): Generator<any, void, any> {
  try {
    const wp: any = yield select((state: any) => state.WpSlice);
    const isWp = wpMode == WpModes.Workplace;
    const lastQuery = isWp ? wp.lastTitleQueryWp : wp.lastTitleQueryTk;
    const titles = isWp ? wp.titles : wp.titlesTk;
    const hasMore = isWp ? wp.titleHasMoreWp : wp.titleHasMoreTk;
    // no prior search to replay, list is empty, dashboard-filtered list (out of scope - see loadPostTitleSaga's isLoadFromStarup), or already known to be the last page
    if (!lastQuery || lastQuery.filterFromDash || titles.length === 0 || !hasMore) {
      yield put(apiOk(type, { wpMode, moreTitles: [] }));
      return;
    }
    const lastTitle = titles[titles.length - 1];
    const response: any[] = yield call(loadPostTitleApiV2, wpMode, lastQuery.keyword, lastQuery.tagSet, lastQuery.memberRole, lastQuery.tagIds, lastQuery.filterUnRead, lastQuery.filterNotClose
      , lastQuery.empFilterType, [], lastQuery.tagCatMatchedAll, "LoadMorePostTitle"
      , lastQuery.taskStatus, false, lastQuery.taskResponder, lastQuery.taskAssigner, lastQuery.taskRequester, lastQuery.taskRange1, lastQuery.taskRange2, lastQuery.includeTaskRecurance, lastQuery.filterTaskDueMode, lastQuery.sortMode
      , lastTitle.postId, lastTitle.lastChatDateEpochMs, lastTitle.planFinishedDateEpochMs, lastTitle.taskStatus, lastTitle.responderName);

    const draftPostIds = Utils.WpDraft_GetAllPostId();
    for (const item of response) {
      item.draft = draftPostIds.includes(item.postId);
    }

    yield put(apiOk(type, { wpMode, moreTitles: response }));
  } catch (e) {
    Utils.HandleException(e, true);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

// function* loadPostConverSaga({ type, payload: { postId } }: any) {
//   try {
//     // console.log('type = ' + type);
//     const response: Promise<any> = yield call(loadPostConverApi, postId);
//     console.log('loadPostConverSaga:', response);
//     yield put(apiOk(type, response));
//   } catch (e) {
//     Utils.HandleException(e, false);
//     yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
//   }
// }

function* setActivePostIdSaga({ type, payload: { activePostInfo, setFrom, wpMode } }: any) {
  try {
    const parm: WpPostInfo = activePostInfo;
    // console.log('setActivePostIdSaga:', setFrom, parm);
    const activePostId = parm.postId;
    if (activePostId) {
      try {
        // const rs: any[] = yield call(DbUtils.wp_load_post_conver, activePostId);
        let rs: any[] = [];
        switch (wpMode) {
          case WpModes.Workplace: rs = yield call(DbUtils.wp_load_post_conver, activePostId); break;
          case WpModes.Task: rs = yield call(DbUtils.wp_load_task_conver, activePostId); break;
        }
        // console.log('loadPostConverSaga Local:', rs);
        if (rs != null) {
          rs.forEach((ee: any) => {
            ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
          });
          //yield put(apiOk(type, rs));
          yield put(apiOk(type, { wpMode, convers: rs }));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }

      try {
        let cachedInfo: WpPostInfo | null = null;
        switch (wpMode) {
          case WpModes.Workplace: cachedInfo = yield call(DbUtils.wp_load_post_info, activePostId); break;
          case WpModes.Task: cachedInfo = yield call(DbUtils.wp_load_task_info, activePostId); break;
        }
        if (cachedInfo != null) {
          yield put(setPostInfoOnly(cachedInfo));
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }

      yield put(loadPostInfo(wpMode, activePostId));
      const response: any[] = yield call(loadPostConverApi2, wpMode, activePostId, null, null, WP_CONVER_PAGE_SIZE);
      // console.log('loadPostConverSaga Api:', { type, response });
      (response ?? []).forEach((ee: any) => {
        ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
      });
      //yield put(apiOk(type, response));
      yield put(apiOk(type, { wpMode, convers: response, converHasMore: (response ?? []).length >= WP_CONVER_PAGE_SIZE }));

      // 20250925 Move to save to mem inside conversation
      // try {
      //   DbUtils.wp_load_post_conver(activePostId, response);
      // } catch (e2) {
      //   Utils.HandleException(e2, false);
      // }      
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* loadMorePostConverSaga({ type, payload: { wpMode, postId, beforePostDateTime, beforePostId } }: any) {
  try {
    const response: any[] = yield call(loadPostConverApi2, wpMode, postId, beforePostDateTime, beforePostId, WP_CONVER_PAGE_SIZE);
    (response ?? []).forEach((ee: any) => {
      ee.bodyHtml = Utils.FixRelativeResourceUrlsForNative(ee.bodyHtml);
    });
    yield put(apiOk(type, { wpMode, moreConvers: response, converHasMore: (response ?? []).length >= WP_CONVER_PAGE_SIZE }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* loadPostInfoSaga({ type, payload: { wpMode, postId } }: any) {
  try {
    if (postId) {
      const response: Promise<any> = yield call(loadPostInfoApi, postId);
      // console.log('loadPostInfoSaga:', response);
      yield put(apiOk(type, response));

      try {
        switch (wpMode) {
          case WpModes.Workplace: yield call(DbUtils.wp_load_post_info, postId, response); break;
          case WpModes.Task: yield call(DbUtils.wp_load_task_info, postId, response); break;
        }
      } catch (e2) {
        Utils.HandleException(e2, false);
      }
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

function* getRoleUnreadCountSaga({ type, payload: { sendNotification } }: any) {
  try {
    const response: Promise<any> = yield call(getRoleUnreadCountApi, sendNotification);
    if (sendNotification == false) {
      // console.log('getRoleUnreadCountSaga:', response);
      yield put(apiOk(type, response));
    }
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageFromExecption(e)));
  }
}

// function* setTagUnreadOnSignalRSaga({ type, payload: { tagUnread } }: any) {
//   try {
//     yield put(apiOk(type, tagUnread));
//   } catch (e) {
//     Utils.HandleException(e, false);
//   }
// }

function* loadDllEmployeeSaga({ type, payload: { } }: any) {
  try {
    const response: Promise<any> = yield call(loadDllEmployeeApi);
    yield put(apiOk(type, response));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashSaga({ type, payload: { divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance } }: any) {
  try {

    if (filterTagId == null) {
      if (type == WpActionTypes.WP_LOAD_TASK_DASH) {
        const local = localStorage.getItem("tkdsh")
        if (local) {
          try {
            const json = JSON.parse(local);
            yield put(apiOk(type, { isLocal: true, data: json }));
          } catch { }
        }
      }
      // const localByDiv = divMode == "DIV_RSP" ? StorageUtils.TaskDashDivMemRsp : divMode == "DIV_ASG" ? StorageUtils.TaskDashDivMemAsg : divMode == "DIV_REQ" ? StorageUtils.TaskDashDivMemReq : null;
      // if (localByDiv) {
      //   try {
      //     const json = JSON.parse(localByDiv);
      //     yield put(apiOk(type, { isLocal: true, divMode, data: json }));
      //   } catch { }
      // }
    }
    // console.log('loadTaskDashSaga: start');
    if (type == WpActionTypes.WP_LOAD_TASK_DASH) {
      const response: Promise<any> = yield call(loadTaskDashApiV2, statusRange1, statusRange2, filterTagId, includeTaskRecurance);
      // console.log('loadTaskDashSaga:', response);
      if (filterTagId == null) {
        localStorage.setItem("tkdsh", JSON.stringify(response));
      }
      yield put(apiOk(type, { isLocal: false, data: response }));
    }

    const byDiv: Promise<any> = yield call(loadTaskDashboardByDivApi, divMode, statusRange1, statusRange2, filterTagId, includeTaskRecurance);
    // console.log('byDiv:', byDiv);
    if (filterTagId == null) {
      const data = JSON.stringify(byDiv);
      if (divMode == "DIV_RSP") StorageUtils.TaskDashDivMemRsp = data;
      else if (divMode == "DIV_ASG") StorageUtils.TaskDashDivMemAsg = data;
      else if (divMode == "DIV_REQ") StorageUtils.TaskDashDivMemReq = data;
    }
    yield put(apiOk(type, { isLocal: false, divMode, byDiv: byDiv }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashRecuranceSaga({ type, payload: { } }: any) {
  try {
    const local = StorageUtils.DashboardTaskRecuranceMem;
    if (local) {
      try {
        const json = JSON.parse(local);
        yield put(apiOk(type, { isLocal: true, data: json }));
      } catch { }
    }

    // console.log('loadTaskDashSaga: start');
    const response: Promise<any> = yield call(loadTaskDashRecuranceApi);
    StorageUtils.DashboardTaskRecuranceMem = JSON.stringify(response);
    yield put(apiOk(type, { isLocal: false, data: response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadTaskDashTagsSaga({ type, payload: { includeTaskRecurance } }: any) {
  try {
    const local = localStorage.getItem("tkdshtags")
    if (local) {
      try {
        const json = JSON.parse(local);
        yield put(apiOk(type, { isLocal: true, data: json }));
      } catch { }
    }
    // console.log('loadTaskDashSaga: start');
    const response: Promise<any> = yield call(loadTaskDashTagsApiV2, includeTaskRecurance);
    // console.log('loadTaskDashTagsSaga:', response);
    localStorage.setItem("tkdshtags", JSON.stringify(response));
    yield put(apiOk(type, { isLocal: false, data: response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}



function* loadTaskDashStatusRangeSaga({ type, payload: { statusRange1, statusRange2, filterTagId, includeTaskRecurance } }: any) {
  try {
    const response: Promise<any> = yield call(loadTaskDashStatusrangeV2Api, statusRange1, statusRange2, filterTagId, includeTaskRecurance);
    // console.log('loadTaskDashStatusrangeApi:', response);
    yield put(apiOk(type, response));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* loadSubTaskSaga({ type, payload: { parentTaskId } }: any) {
  try {
    const response: Promise<any> = yield call(loadSubTaskApi, parentTaskId);
    console.log('loadSubTaskApi:', response);
    yield put(apiOk(type, { parentTaskId, response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

function* tagMasterCatLoadSaga({ type, payload: { } }: any) {
  try {
    const response: Promise<any> = yield call(tagMasterCatLoadApi);
    yield put(apiOk(type, { response }));
  } catch (e) {
    Utils.HandleException(e, false);
    yield put(apiErr(type, Utils.GetMessageDividerElement(e)));
  }
}

/* watched function */
export function* loadPostTitleWatch() {
  // yield takeLatest(WpActionTypes.LOAD_POST_TITLE, loadPostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_POST_TITLE_WP, loadPostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_POST_TITLE_TK, loadPostTitleSaga);
}

export function* loadMorePostTitleWatch() {
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_TITLE_WP, loadMorePostTitleSaga);
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_TITLE_TK, loadMorePostTitleSaga);
}

// export function* loadPostConverWatch() {
//   yield takeLatest(WpActionTypes.LOAD_POST_CONVER, loadPostConverSaga);
// }

export function* setActivePostIdWatch() {
  //yield takeLatest(WpActionTypes.SET_ACTIVE_POSTID, setActivePostIdSaga);
  yield takeLatest(WpActionTypes.SET_ACTIVE_POSTID2, setActivePostIdSaga);
}

export function* loadMorePostConverWatch() {
  yield takeLatest(WpActionTypes.LOAD_MORE_POST_CONVER, loadMorePostConverSaga);
}

export function* loadPostInfoWatch() {
  yield takeLatest(WpActionTypes.LOAD_POST_INFO2, loadPostInfoSaga);
}

export function* getRoleUnreadCountWatch() {
  yield takeLatest(WpActionTypes.GET_ROLE_UNREAD_COUNT, getRoleUnreadCountSaga);
}

// export function* setTagUnreadOnSignalRWatch(){
//   yield takeEvery(WpActionTypes.TAG_UNREAD_ON_SIGNALR, setTagUnreadOnSignalRSaga);
// }

export function* loadDllEmployeeWatch() {
  yield takeLatest(WpActionTypes.LOAD_DLL_EMPLOYEE, loadDllEmployeeSaga);
}

export function* loadTaskDashWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH, loadTaskDashSaga);
}

export function* loadTaskDashWatchByDiv() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASHBOARD_BY_DIV, loadTaskDashSaga);
}


export function* loadTaskDashRecuranceWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_RECURANCE, loadTaskDashRecuranceSaga);
}

export function* loadTaskDashTagsWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_TAGS, loadTaskDashTagsSaga);
}

export function* loadTaskDashStatusRangeWatch() {
  yield takeLatest(WpActionTypes.WP_LOAD_TASK_DASH_STATUSRANGE, loadTaskDashStatusRangeSaga);
}

export function* loadSubTaskWatch() {
  yield takeEvery(WpActionTypes.WP_LOAD_SUB_TASK, loadSubTaskSaga);
}

export function* tagMasterCatLoadWatch() {
  yield takeLatest(WpActionTypes.WP_TAG_MASTER_CAT_LOAD, tagMasterCatLoadSaga);
}






/* main function */
function* wpSaga() {
  yield all([
    fork(loadPostTitleWatch),
    fork(loadMorePostTitleWatch),
    fork(setActivePostIdWatch),
    fork(loadMorePostConverWatch),
    fork(loadPostInfoWatch),
    fork(getRoleUnreadCountWatch),
    fork(loadDllEmployeeWatch),
    fork(loadTaskDashWatch),
    fork(loadTaskDashWatchByDiv),
    fork(loadTaskDashRecuranceWatch),
    fork(loadTaskDashStatusRangeWatch),
    fork(loadSubTaskWatch),
    fork(loadTaskDashTagsWatch),
    fork(tagMasterCatLoadWatch),
    // fork(setTagUnreadOnSignalRWatch),
  ]);
}

export default wpSaga;